export default __webpack_public_path__ + "static/media/03.8456c2f8.jpg";